const ProductsActionTypes = {
	START_LOADING_PRODUCTS: 'START_LOADING_PRODUCTS',
	UPDATE_PRODUCTS_DATA: 'UPDATE_PRODUCTS_DATA',
	UPDATE_ERROR_PRODUCTS: 'UPDATE_ERROR_PRODUCTS'
};

export default ProductsActionTypes;
